import { constantTree } from "../../../core/events/ConstantTree";

export const fmlmSearchTree = constantTree({
  Search: {
    SearchOnChange: "",
  },
  selectLocationForOrigin: {
    select: "",
  },
  selectLocationForDestination: {
    select: "",
  },
  selectStops: {
    Select: "",
  },
  Stops: {
    Updated: "",
  },
  ConfirmFmlmSearch: {
    Click: "",
  },
  JourneyPlannerSelectLocation: {
    Click: ""
  },
  LoadMore: {
    Click: "",
  },
  Favourite: {
    Stop: {
      Click: "",
    },
    Location: {
      Click: "",
    },
  },
  SubStations: {
    Click: "",
  },
  close: {
    Click: "",
  },
  ReverseGeocode: {
    Execute: "",
  },
  CurrentLocation: {
    Click: "",
  },
  SelectJourney: {
    Select: "",
  },
});
